import { useId, type ReactNode } from 'react';
import { IconXMark } from '@/components/icons/IconXMark';
import { CHAT_WIDGET_COPY } from './chat-widget.constants';

type ChatPanelProps = {
    id: string;
    title: string;
    onClose: () => void;
    children: ReactNode;
};

/** Card above the launcher. The title is no heading: the widget sits outside the page outline. */
export function ChatPanel({ id, title, onClose, children }: ChatPanelProps) {
    const titleId = useId();

    return (
        <section
            id={id}
            aria-labelledby={titleId}
            className="w-[calc(100vw-2rem)] max-w-page-4xs rounded-(--r) border border-(--border) bg-(--surface) p-5 shadow-[0_4px_16px_rgba(var(--media-badge-bg),0.24)]"
        >
            <div className="flex items-start justify-between gap-3">
                <p id={titleId} className="label-md font-semibold">
                    {title}
                </p>
                <button
                    type="button"
                    onClick={onClose}
                    aria-label={CHAT_WIDGET_COPY.close}
                    className="-me-1.5 -mt-1.5 inline-flex size-8 shrink-0 cursor-pointer items-center justify-center rounded-full text-(--muted) transition-colors hover:text-(--text) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--focus-ring)"
                >
                    <IconXMark width={20} height={20} aria-hidden="true" />
                </button>
            </div>
            {children}
        </section>
    );
}
